import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useAuthRequired } from '../../contexts/AuthRequiredContext';
import { consumeBookingAccessMismatch } from '../../utils/bookingAccessMismatch';
import { saveAuthReturnTo } from '../../utils/authReturnTo';
import '../Profile/Profile.css';

const BookingAccessMismatchModal = () => {
  const { logout } = useAuth();
  const { triggerAuthModal } = useAuthRequired();
  const [mismatch, setMismatch] = useState(null);
  const [signingOut, setSigningOut] = useState(false);

  useEffect(() => {
    const payload = consumeBookingAccessMismatch();
    if (payload) {
      setMismatch(payload);
    }
  }, []);

  if (!mismatch) return null;

  const bookingEmail = mismatch.bookingEmail || 'the booking customer';
  const loggedInEmail = mismatch.loggedInEmail || 'your current account';

  const handleDismiss = () => {
    setMismatch(null);
  };

  const handleSignOutAndSignIn = async () => {
    if (mismatch.returnPath) {
      saveAuthReturnTo(mismatch.returnPath);
    }
    setSigningOut(true);
    try {
      await logout();
      setMismatch(null);
      triggerAuthModal();
    } finally {
      setSigningOut(false);
    }
  };

  return (
    <div className="profile-message-modal-overlay" role="dialog" aria-modal="true">
      <div className="profile-message-modal">
        <h3>Sign in with the correct account</h3>
        <p className="profile-message-modal-subtitle">
          This booking is linked to <strong>{bookingEmail}</strong>, but you are signed in as{' '}
          <strong>{loggedInEmail}</strong>. Sign out and sign in with the account that matches your
          booking email to view or pay for this booking.
        </p>
        <div className="profile-message-modal-actions">
          <button
            type="button"
            className="booking-view-details-button"
            onClick={handleDismiss}
            disabled={signingOut}
          >
            Dismiss
          </button>
          <button
            type="button"
            className="booking-view-details-button booking-view-details-button--primary"
            onClick={handleSignOutAndSignIn}
            disabled={signingOut}
          >
            {signingOut ? 'Signing out…' : 'Sign out and sign in'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingAccessMismatchModal;
